<script>
/* global axios */
import { useAlert } from 'dashboard/composables';

/* Construtor visual do roteiro de atendimento (por caixa).
   Canvas feito em Vue 3 + SVG puro DE PROPÓSITO: a imagem do Chatwoot builda com
   `pnpm install --frozen-lockfile`, então qualquer dependência nova (vue-flow e
   afins) quebraria o build inteiro. Aqui não há dependência alguma. */

// Os formatos e limites acompanham a API oficial do WhatsApp (botões até 3,
// lista até 10, carrossel de 2 a 10 cards) — assim o roteiro fica compatível
// caso um dia seja levado para lá.
const TYPES = [
  { type: 'message',   label: 'Mensagem',      icon: '💬', hint: 'Só fala e segue' },
  { type: 'buttons',   label: 'Botões',        icon: '🔘', hint: 'Até 3 opções' },
  { type: 'list',      label: 'Lista',         icon: '📋', hint: 'De 4 a 10 opções' },
  { type: 'carousel',  label: 'Carrossel',     icon: '🎠', hint: 'Cards com imagem e botões' },
  { type: 'input',     label: 'Pedir dado',    icon: '🆔', hint: 'CPF, telefone...' },
  { type: 'link',      label: 'Botão de link', icon: '🔗', hint: 'Abre uma URL' },
  { type: 'image',     label: 'Imagem',        icon: '🖼️', hint: 'Envia uma foto' },
  { type: 'delay',     label: 'Digitando',     icon: '⏳', hint: 'Pausa com "digitando…"' },
  { type: 'condition', label: 'Condição',      icon: '🔀', hint: 'Se/senão' },
  { type: 'ai',        label: 'Passar para IA',icon: '🤖', hint: 'IA assume' },
  { type: 'bot',       label: 'Transferir para IA', icon: '🤖', hint: 'Entrega a conversa para outra IA (ex.: FGTS IA)' },
  { type: 'agent',     label: 'Passar p/ humano', icon: '🙋', hint: 'Atendente assume' },
  { type: 'http',      label: 'HTTP',          icon: '🌐', hint: 'Chama uma API (estilo n8n)' },
  { type: 'supabase',  label: 'Supabase',      icon: '🗄️', hint: 'Insere/consulta no banco' },
  { type: 'script',    label: 'Script',        icon: '🐍', hint: 'Roda Python isolado' },
  { type: 'splash',    label: 'Destaque',      icon: '✨', hint: 'Estoura na tela com imagem/vídeo (só webchat)' },
  { type: 'oferta',    label: 'Consultar oferta', icon: '💰', hint: 'Consulta os bancos de verdade e guarda o que achou' },
  { type: 'ofertas',   label: 'Mostrar ofertas',  icon: '🏷️', hint: 'Mostra os cards das ofertas e espera o cliente escolher' },
  { type: 'end',       label: 'Encerrar',      icon: '🏁', hint: 'Fim do roteiro' },
];
const MAX_OPTIONS = { buttons: 3, list: 10 };
const MAX_CARDS = 10;
// Bancos do bloco "Consultar oferta". É a MESMA lista do servidor (FLOW_BANCOS
// no mazam_web_controller.rb): banco fora dela é descartado ao salvar, então as
// duas precisam andar juntas.
const BANCOS = [
  { id: 'soma_cel', nome: 'SOMA — Celetista' },
  { id: 'soma_uy3', nome: 'SOMA — UY3' },
  { id: 'v8', nome: 'V8' },
  { id: 'c6', nome: 'C6' },
  { id: 'facta', nome: 'Facta' },
  { id: 'uy3', nome: 'UY3' },
];
const OFERTA_TETO_PADRAO = 25;
// Bloco "Transferir para IA": sugestão para o caso que criou o bloco (o menu
// CLT × FGTS, em que o ramo FGTS cai na FGTS IA, que é o agent bot 1). É só
// SUGESTÃO de tela — quem manda no padrão de verdade é o servidor
// (WEBCHAT_BOT_FGTS_ID / WEBCHAT_URL_IA_FGTS), usado quando o campo fica vazio.
const BOT_PADRAO = {
  bot_id: 1,
  url: 'https://atendimento-ia.mazam.ai/fgts-ia/webhook/chatwoot',
  gatilho: 'Quero antecipar meu FGTS',
};

const NODE_W = 210;
const NODE_H = 92;

export default {
  props: {
    inbox: { type: Object, required: true },
    // 'webchat' (default, comportamento atual) ou 'whatsapp'. No WhatsApp valem
    // as regras da Meta e alguns campos não existem (ex.: travar o compositor
    // do cliente é impossível — ele sempre pode digitar).
    channel: { type: String, default: 'webchat' },
    // Embutido dentro da tela de IA do WhatsApp: quem salva é o pai.
    embedded: { type: Boolean, default: false },
    // IAs criadas na caixa: alimentam o seletor do bloco "Passar para IA".
    agentesIa: { type: Array, default: () => [] },
  },
  data() {
    return {
      enabled: false,
      start: '',
      nodes: [],
      selectedId: null,
      saving: false,
      loading: true,
      pan: { x: 40, y: 30 },
      zoom: 1,
      drag: null,        // { id, dx, dy } arrastando um nó
      panning: null,     // { x, y } arrastando o fundo
      linking: null,     // { from, port, x, y } ligando saída -> nó
      types: TYPES,
      bancosDisponiveis: BANCOS,
      sim: null,         // simulação do "Testar"
      full: false,       // canvas em tela cheia
      sbTabelas: [],     // tabelas Supabase liberadas nesta caixa
      sbColunas: [],     // colunas da tabela selecionada
      sbCarregando: false,
      acaoTestando: false,
      acaoResultado: '', // retorno do "Testar" de um nó de ação
      templates: [],     // modelos de roteiro salvos (servem a qualquer caixa)
      tplSel: '',
      // IA desta caixa: modelo e chave próprios. A chave NUNCA volta do
      // servidor — só a dica do fim, para reconhecer qual está gravada.
      iaModelo: 'gpt-5-mini',
      iaChave: '',
      iaTemChave: false,
      iaDica: '',
      iaSalvando: false,
      modelos: ['gpt-5-mini', 'gpt-5', 'gpt-4.1', 'gpt-4.1-mini', 'gpt-4o', 'gpt-4o-mini'],
    };
  },
  computed: {
    accountId() { return this.$route.params.accountId; },
    selected() { return this.nodes.find(n => n.id === this.selectedId) || null; },
    nodeById() {
      const m = {};
      this.nodes.forEach(n => { m[n.id] = n; });
      return m;
    },
    /* Uma aresta por saída: nós simples têm "next"; botões têm uma por opção;
       condição tem sim/não. */
    edges() {
      const out = [];
      this.nodes.forEach(n => {
        const ports = this.portsOf(n);
        ports.forEach((p, i) => {
          const target = this.nodeById[p.next];
          if (!target) return;
          out.push({
            key: `${n.id}:${i}`,
            from: n.id,
            port: i,
            d: this.pathBetween(n, i, ports.length, target),
            mid: this.midBetween(n, i, ports.length, target),
            label: p.label || '',
          });
        });
      });
      return out;
    },
    problems() {
      const out = [];
      if (!this.nodes.length) return out;
      if (!this.nodeById[this.start]) out.push('Nenhum bloco inicial definido.');
      const reachable = new Set();
      const walk = id => {
        if (!id || reachable.has(id) || !this.nodeById[id]) return;
        reachable.add(id);
        this.portsOf(this.nodeById[id]).forEach(p => walk(p.next));
      };
      walk(this.start);
      this.nodes.forEach(n => {
        if (!reachable.has(n.id)) out.push(`"${this.titleOf(n)}" não é alcançável a partir do início.`);
        const ports = this.portsOf(n);
        const dead = ports.filter(p => !p.next).length;
        if (dead && !['ai', 'agent', 'end'].includes(n.type)) {
          out.push(`"${this.titleOf(n)}" tem ${dead} saída(s) sem destino.`);
        }
        if ((n.type === 'buttons' || n.type === 'list') && !(n.options || []).length) {
          out.push(`"${this.titleOf(n)}" não tem nenhuma opção.`);
        }
        if (n.type === 'carousel') {
          if ((n.cards || []).length < 2) {
            out.push(`"${this.titleOf(n)}" precisa de pelo menos 2 cards.`);
          }
          const qtd = new Set((n.cards || []).map(c => (c.buttons || []).length));
          if (qtd.size > 1) {
            out.push(`"${this.titleOf(n)}": todos os cards precisam ter a mesma quantidade de botões.`);
          }
        }
        if (n.type === 'link' && !n.url) out.push(`"${this.titleOf(n)}" está sem URL.`);
        if (n.type === 'image' && !n.src) out.push(`"${this.titleOf(n)}" está sem a URL da imagem.`);
        if (n.type === 'oferta' && !(n.salvar_em || '').trim()) {
          out.push(`"${this.titleOf(n)}" está sem o nome da variável onde guardar as ofertas.`);
        }
      });
      return out;
    },
  },
  mounted() {
    this.load();
    if (!this.embedded) this.loadIa();
    this.carregarTabelas();
    this.carregarTemplates();
    window.addEventListener('keydown', this.onKey);
  },
  watch: {
    // Ao abrir um nó Supabase, puxa as colunas da tabela dele; o resultado do
    // teste anterior some para não confundir com outro nó.
    selectedId() {
      this.acaoResultado = '';
      const n = this.selected;
      // Nó de oferta vindo de um modelo antigo pode chegar sem os campos novos;
      // sem isto o v-model dos checkboxes não teria array para marcar.
      if (n && n.type === 'oferta') {
        if (!Array.isArray(n.bancos)) n.bancos = [];
        if (!n.teto_s) n.teto_s = OFERTA_TETO_PADRAO;
        if (!n.salvar_em) n.salvar_em = 'ofertas';
      }
      if (n && n.type === 'supabase' && n.tabela) this.carregarColunas(n.tabela);
      else this.sbColunas = [];
    },
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKey);
    document.body.style.overflow = '';
  },
  methods: {
    /* Tela cheia: o canvas ocupa a janela inteira para montar fluxo grande sem
       ficar espremido na coluna do painel. Esc também fecha. */
    toggleFull() {
      this.full = !this.full;
      document.body.style.overflow = this.full ? 'hidden' : '';
    },
    onKey(e) {
      if (e.key !== 'Escape') return;
      // O telefone fecha primeiro: ele está por cima da tela cheia.
      if (this.sim) { this.sim = null; return; }
      if (this.full) this.toggleFull();
    },
    /* Rola a conversa e põe o cursor no campo — sem isto o teste trava com o
       cliente sem saber onde digitar. */
    simFocus() {
      this.$nextTick(() => {
        const box = this.$refs.simScroll;
        if (box) box.scrollTop = box.scrollHeight;
        const inp = this.$refs.simInput;
        if (inp && inp.focus) setTimeout(() => inp.focus(), 60);
      });
    },
    titleOf(n) {
      const t = TYPES.find(x => x.type === n.type);
      const txt = (n.text || '').trim();
      return txt ? txt.slice(0, 28) : (t ? t.label : n.type);
    },
    iconOf(n) {
      const t = TYPES.find(x => x.type === n.type);
      return t ? t.icon : '•';
    },
    /* Uma saída por caminho possível: cada botão/item tem a sua (menos os de
       link, que abrem numa aba e não avançam), o carrossel tem uma por botão de
       card, e condição/consulta de oferta têm duas. */
    portsOf(n) {
      if (n.type === 'buttons' || n.type === 'list') {
        return (n.options || []).filter(o => !o.url).map(o => ({ label: o.label, next: o.next }));
      }
      if (n.type === 'carousel') {
        const out = [];
        (n.cards || []).forEach(c => {
          (c.buttons || []).forEach(b => {
            if (!b.url) out.push({ label: `${c.title || 'card'}: ${b.label}`, next: b.next });
          });
        });
        return out;
      }
      if (n.type === 'condition') {
        return [{ label: 'sim', next: n.next }, { label: 'não', next: n.else }];
      }
      if (n.type === 'oferta') {
        return [{ label: 'achou oferta', next: n.next }, { label: 'não achou', next: n.else }];
      }
      if (['ai', 'agent', 'end'].includes(n.type)) return [];
      return [{ label: '', next: n.next }];
    },
    setPort(n, i, targetId) {
      if (n.type === 'buttons' || n.type === 'list') {
        // Opção com link não tem saída, então o índice conta só as que avançam.
        let k = 0;
        (n.options || []).forEach(o => {
          if (o.url) return;
          if (k === i) o.next = targetId;
          k += 1;
        });
      } else if (n.type === 'carousel') {
        let k = 0;
        (n.cards || []).forEach(c => {
          (c.buttons || []).forEach(b => {
            if (b.url) return;
            if (k === i) b.next = targetId;
            k += 1;
          });
        });
      } else if (n.type === 'condition' || n.type === 'oferta') {
        if (i === 0) n.next = targetId; else n.else = targetId;
      } else { n.next = targetId; }
    },
    portPos(n, i, total) {
      const step = NODE_W / (total + 1);
      return { x: n.x + step * (i + 1), y: n.y + NODE_H };
    },
    /* Meio da curva — é onde fica a lixeira de desfazer a ligação.
       Bezier cúbica em t=0.5: (P0 + 3P1 + 3P2 + P3) / 8. */
    midBetween(from, i, total, to) {
      const a = this.portPos(from, i, total);
      const b = { x: to.x + NODE_W / 2, y: to.y };
      const dy = Math.max(30, Math.abs(b.y - a.y) / 2);
      const c1 = { x: a.x, y: a.y + dy };
      const c2 = { x: b.x, y: b.y - dy };
      return {
        x: (a.x + 3 * c1.x + 3 * c2.x + b.x) / 8,
        y: (a.y + 3 * c1.y + 3 * c2.y + b.y) / 8,
      };
    },
    /* Desfaz a ligação: some a seta e a saída volta a ficar livre. */
    removeEdge(e) {
      const n = this.nodeById[e.from];
      if (n) this.setPort(n, e.port, null);
    },
    pathBetween(from, i, total, to) {
      const a = this.portPos(from, i, total);
      const b = { x: to.x + NODE_W / 2, y: to.y };
      const dy = Math.max(30, Math.abs(b.y - a.y) / 2);
      return `M ${a.x} ${a.y} C ${a.x} ${a.y + dy}, ${b.x} ${b.y - dy}, ${b.x} ${b.y}`;
    },

    // ---- carga / gravação ------------------------------------------------
    /* Entrega o roteiro para quem embute (a tela de IA do WhatsApp salva tudo
       junto, num POST só — dois botões de salvar na mesma tela é a receita
       clássica de perder trabalho). */
    async loadIa() {
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/ia`,
          { params: { inbox_id: this.inbox.id } }
        );
        this.iaModelo = data.modelo || 'gpt-5-mini';
        this.iaTemChave = !!data.tem_chave;
        this.iaDica = data.chave_dica || '';
      } catch (e) { /* caixa sem config ainda */ }
    },
    async salvarIa() {
      this.iaSalvando = true;
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/mazam_web/ia_credencial`,
          { inbox_id: this.inbox.id, modelo: this.iaModelo, chave: this.iaChave }
        );
        this.iaTemChave = !!data.tem_chave;
        this.iaDica = data.chave_dica || '';
        this.iaChave = '';
        useAlert('IA desta caixa salva.');
      } catch (e) {
        useAlert('Não foi possível salvar a IA.');
      }
      this.iaSalvando = false;
    },
    exportFlow() {
      return { enabled: this.enabled, start: this.start, nodes: this.nodes };
    },
    async load() {
      this.loading = true;
      try {
        // Os dois canais leem da MESMA configuração agora (o roteiro do
        // webchat migra de additional_attributes no primeiro salvamento).
        const rota = this.embedded ? 'mazam_web/ia' : 'mazam_web/flow';
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/${rota}`,
          { params: { inbox_id: this.inbox.id } }
        );
        const f = (this.embedded ? (data.config || {}).flow : data.flow) || {};
        this.enabled = f.enabled === true;
        this.nodes = (f.nodes || []).map(n => ({
          options: [], cards: [], field: '', error: '', validate: 'texto',
          var: '', op: 'preenchido', value: '', else: null, label: '',
          url: '', src: '', button: 'Ver opções', seconds: 2, agent: '',
          allow_text: true, x: 40, y: 40, text: '', next: null,
          // nós de ação: defaults para o painel não quebrar em roteiro antigo
          metodo: 'GET', headers: [], query: [], body_modo: 'none', body: '',
          timeout_seg: 10, mapear: [], salvar_em: '', code: '', env: {},
          tabela: '', valores: {}, filtros: {}, limit: 10,
          titulo: '', midia: '', botoes: [], ...n,
        }));
        this.start = f.start || (this.nodes[0] ? this.nodes[0].id : '');
        if (!this.nodes.length) this.seed();
        // Roteiro antigo (ou migrado) não tem coordenada: sem isto TODOS os
        // blocos caem no mesmo ponto e ficam empilhados, ilegíveis.
        this.organizarSePreciso();
      } catch (e) {
        this.seed();
      }
      this.loading = false;
    },
    /* Roteiro de exemplo: já sai do zero com um caminho que funciona, para o
       usuário editar em vez de encarar tela em branco. */
    seed() {
      this.nodes = [
        { id: 'n1', type: 'message', x: 60, y: 40, next: 'n2',
          text: 'Sou a Julia, da Mazam. Gostaria de antecipar o saldo do seu FGTS?' },
        { id: 'n2', type: 'buttons', x: 60, y: 200, text: '', field: 'escolha', allow_text: true,
          options: [{ label: 'Sim, quero', next: 'n3' }, { label: 'Ver produtos', next: null }] },
        { id: 'n3', type: 'input', x: 60, y: 360, validate: 'cpf', field: 'cpf', next: 'n4',
          text: 'Perfeito! Me informa seu CPF, por favor.',
          error: 'Esse CPF não confere. Pode revisar?' },
        { id: 'n4', type: 'ai', x: 60, y: 520, text: 'Só um instante, já vou verificar.' },
      ];
      this.start = 'n1';
    },
    async save() {
      this.saving = true;
      try {
        await axios.post(`/api/v1/accounts/${this.accountId}/mazam_web/flow`, {
          inbox_id: this.inbox.id,
          flow: { enabled: this.enabled, start: this.start, nodes: this.nodes },
        });
        useAlert('Roteiro salvo.');
      } catch (e) {
        useAlert('Não foi possível salvar o roteiro.');
      }
      this.saving = false;
    },

    // ---- edição ----------------------------------------------------------
    newId() {
      let i = 1;
      while (this.nodeById[`n${i}`]) i += 1;
      return `n${i}`;
    },
    addNode(type) {
      const id = this.newId();
      const n = {
        id, type, text: '', next: null, options: [], field: '', error: '',
        validate: 'texto', var: '', op: 'preenchido', value: '', else: null,
        label: '', allow_text: true,
        x: Math.round(60 - this.pan.x / this.zoom + 260 * ((this.nodes.length % 3))),
        y: Math.round(60 - this.pan.y / this.zoom + 150 * Math.floor(this.nodes.length / 3)),
      };
      if (type === 'buttons') n.options = [{ label: 'Sim', value: '', next: null }];
      if (type === 'list') {
        n.options = [{ label: 'Opção 1', value: '', description: '', next: null }];
        n.button = 'Ver opções';
      }
      if (type === 'carousel') {
        n.cards = [
          { image: '', title: 'Oferta 1', body: '', buttons: [{ label: 'Quero esta', value: '', url: '', next: null }] },
          { image: '', title: 'Oferta 2', body: '', buttons: [{ label: 'Quero esta', value: '', url: '', next: null }] },
        ];
      }
      if (type === 'link') { n.label = 'Abrir'; n.url = ''; }
      if (type === 'delay') n.seconds = 2;
      if (type === 'ai') n.agent = '';
      if (type === 'input') { n.validate = 'cpf'; n.field = 'cpf'; }
      if (type === 'http') {
        n.metodo = 'GET'; n.url = ''; n.headers = []; n.query = [];
        n.body_modo = 'none'; n.body = ''; n.timeout_seg = 10;
        n.mapear = []; n.salvar_em = 'resposta';
      }
      if (type === 'supabase') {
        n.op = 'inserir'; n.tabela = ''; n.valores = {}; n.filtros = {};
        n.limit = 10; n.salvar_em = 'consulta';
      }
      if (type === 'splash') {
        n.titulo = 'Novidade!';
        n.midia = '';
        n.botoes = [{ label: 'OK', url: '' }];
      }
      if (type === 'script') { n.code = '# vars é o dicionário do fluxo\n# o que você puser em vars volta pro roteiro\n'; n.env = {}; n.salvar_em = 'saida'; }
      if (type === 'oferta') {
        // Lista de bancos vazia = consulta todos os que a caixa tiver liberado.
        n.bancos = []; n.teto_s = OFERTA_TETO_PADRAO; n.salvar_em = 'ofertas';
      }
      if (type === 'ofertas') n.text = 'Olha o que eu consegui pra você:';
      if (type === 'bot') {
        // Padrão = FGTS IA (bot 1), que é o caso de uso que criou este bloco.
        // Deixar em branco também funciona: o servidor usa o padrão dele.
        n.bot_id = BOT_PADRAO.bot_id;
        n.url = BOT_PADRAO.url;
        n.gatilho = BOT_PADRAO.gatilho;
        n.text = 'Vou te passar para a nossa especialista, um instante.';
      }
      this.nodes.push(n);
      if (!this.start) this.start = id;
      this.selectedId = id;
    },
    // ---- modelos de roteiro (templates) ----
    // Ficam FORA da caixa (InstallationConfig global): monta uma vez e reusa em
    // quantas caixas quiser, que é justamente a razão de existirem.
    async carregarTemplates() {
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`);
        this.templates = data.templates || [];
      } catch (e) {
        this.templates = [];
      }
    },
    async salvarTemplate() {
      const nome = window.prompt('Nome do modelo (ex.: "Boas-vindas + CPF"):', '');
      if (!nome || !nome.trim()) return;
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`,
          { nome: nome.trim(), flow: { start: this.start, nodes: this.nodes } });
        this.templates = data.templates || [];
        this.tplSel = data.id || '';
        useAlert('Modelo salvo. Já dá para usar em outra caixa.');
      } catch (e) {
        useAlert(e.response?.data?.error || 'Não consegui salvar o modelo.');
      }
    },
    async usarTemplate() {
      const t = this.templates.find(x => x.id === this.tplSel);
      if (!t) return;
      // Substituir o roteiro é destrutivo: confirma antes, dizendo o que perde.
      if (this.nodes.length && !window.confirm(
        `Carregar o modelo "${t.nome}" SUBSTITUI o roteiro que está na tela `
        + `(${this.nodes.length} bloco(s)). Continuar?`)) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`,
          { params: { id: this.tplSel } });
        const f = data.flow || {};
        this.nodes = (f.nodes || []).map(n => ({ ...n }));
        this.start = f.start || (this.nodes[0] ? this.nodes[0].id : '');
        this.selectedId = null;
        this.organizarSePreciso();
        useAlert('Modelo carregado. Revise e clique em salvar para valer nesta caixa.');
      } catch (e) {
        useAlert('Não consegui carregar o modelo.');
      }
    },
    async excluirTemplate() {
      const t = this.templates.find(x => x.id === this.tplSel);
      if (!t) return;
      if (!window.confirm(`Excluir o modelo "${t.nome}"? Isso não afeta os roteiros já salvos nas caixas.`)) return;
      try {
        const { data } = await axios.delete(
          `/api/v1/accounts/${this.accountId}/mazam_web/flow_templates`,
          { params: { id: this.tplSel } });
        this.templates = data.templates || [];
        this.tplSel = '';
        useAlert('Modelo excluído.');
      } catch (e) {
        useAlert('Não consegui excluir o modelo.');
      }
    },
    // ---- organização automática dos blocos ----
    // Só reposiciona quando é necessário: roteiro sem coordenada (formato
    // antigo/migrado) ou com todos os blocos no mesmo ponto. Um roteiro que o
    // usuário já arrumou à mão NÃO é mexido.
    organizarSePreciso() {
      if (!this.nodes.length) return;
      const semCoord = this.nodes.some(
        n => n.x === null || n.x === undefined || n.y === null || n.y === undefined
      );
      const primeiros = `${this.nodes[0].x},${this.nodes[0].y}`;
      const todosIguais = this.nodes.every(n => `${n.x},${n.y}` === primeiros);
      if (semCoord || (this.nodes.length > 1 && todosIguais)) this.organizar();
    },
    /* Arruma em colunas por PROFUNDIDADE: cada passo do roteiro anda para a
       direita, e caminhos paralelos (botões/condição) descem em linhas. Assim o
       desenho fica na ordem em que a conversa acontece. */
    organizar() {
      const COL = 300;
      const LIN = 170;
      const nivel = {};
      const fila = [];
      const inicio = this.nodeById[this.start] ? this.start : this.nodes[0].id;
      nivel[inicio] = 0;
      fila.push(inicio);
      let guard = 0;
      while (fila.length && guard < 400) {
        guard += 1;
        const id = fila.shift();
        this.portsOf(this.nodeById[id] || {}).forEach(p => {
          if (p.next && this.nodeById[p.next] && nivel[p.next] === undefined) {
            nivel[p.next] = nivel[id] + 1;
            fila.push(p.next);
          }
        });
      }
      // Bloco solto (ninguém aponta pra ele) vai para uma coluna extra ao lado.
      const maxNivel = Math.max(0, ...Object.values(nivel));
      this.nodes.forEach(n => {
        if (nivel[n.id] === undefined) nivel[n.id] = maxNivel + 1;
      });
      const usadosPorColuna = {};
      this.nodes
        .slice()
        .sort((a, b) => nivel[a.id] - nivel[b.id])
        .forEach(n => {
          const c = nivel[n.id];
          usadosPorColuna[c] = (usadosPorColuna[c] || 0);
          n.x = 60 + c * COL;
          n.y = 60 + usadosPorColuna[c] * LIN;
          usadosPorColuna[c] += 1;
        });
      this.fitView();
    },
    // ---- nós de ação: helpers de UI ----
    // Objeto {k:v} <-> texto "k=v" por linha (valores/filtros/env).
    // Vídeo (arquivo ou YouTube) não tem prévia de imagem no editor.
    ehVideo(u) {
      return /\.(mp4|webm|ogg|mov)(\?|$)/i.test(u || '') || /youtu\.?be|youtube\.com/i.test(u || '');
    },
    kvText(obj) {
      if (!obj || typeof obj !== 'object') return '';
      return Object.entries(obj).map(([k, v]) => `${k}=${v}`).join('\n');
    },
    setKv(node, campo, texto) {
      const out = {};
      String(texto || '').split('\n').forEach(linha => {
        const i = linha.indexOf('=');
        if (i > 0) {
          const k = linha.slice(0, i).trim();
          if (k) out[k] = linha.slice(i + 1).trim();
        }
      });
      node[campo] = out;
    },
    async carregarTabelas(preselecionada) {
      this.sbCarregando = true;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/supabase_tabelas`,
          { params: { inbox_id: this.inbox.id } });
        this.sbTabelas = data.liberadas || [];
        if (preselecionada) await this.carregarColunas(preselecionada);
      } catch (e) {
        this.sbTabelas = [];
      } finally {
        this.sbCarregando = false;
      }
    },
    async carregarColunas(tabela) {
      this.sbColunas = [];
      if (!tabela) return;
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/mazam_web/supabase_colunas`,
          { params: { inbox_id: this.inbox.id, tabela } });
        this.sbColunas = data.colunas || [];
      } catch (e) { /* tabela vazia/sem permissão: segue sem dica */ }
    },
    async testarAcao(node) {
      this.acaoTestando = true;
      this.acaoResultado = '';
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/mazam_web/acao_test`,
          { inbox_id: this.inbox.id, node, vars: {} });
        this.acaoResultado = JSON.stringify(data, null, 2);
      } catch (e) {
        this.acaoResultado = 'Falhou: ' + (e.response?.data?.erro || e.message);
      } finally {
        this.acaoTestando = false;
      }
    },
    removeNode(id) {
      this.nodes = this.nodes.filter(n => n.id !== id);
      this.nodes.forEach(n => {
        if (n.next === id) n.next = null;
        if (n.else === id) n.else = null;
        (n.options || []).forEach(o => { if (o.next === id) o.next = null; });
      });
      if (this.start === id) this.start = this.nodes[0] ? this.nodes[0].id : '';
      if (this.selectedId === id) this.selectedId = null;
    },
    addOption(n) {
      const max = MAX_OPTIONS[n.type] || 3;
      if ((n.options || []).length >= max) return;
      n.options.push({ label: 'Nova opção', value: '', description: '', next: null });
    },
    maxOptions(n) { return MAX_OPTIONS[n.type] || 3; },
    addCard(n) {
      if ((n.cards || []).length >= MAX_CARDS) return;
      // A Meta exige a MESMA quantidade de botões em todos os cards; o card novo
      // já nasce copiando os rótulos do primeiro para não sair torto.
      const base = (n.cards[0] && n.cards[0].buttons) || [{ label: 'Quero esta' }];
      n.cards.push({
        image: '', title: `Oferta ${n.cards.length + 1}`, body: '',
        buttons: base.map(b => ({ label: b.label, value: '', url: '', next: null })),
      });
    },
    addCardButton(n) {
      if (!n.cards.length || n.cards[0].buttons.length >= 2) return;
      n.cards.forEach(c => c.buttons.push({ label: 'Novo botão', value: '', url: '', next: null }));
    },
    removeCardButton(n, i) {
      n.cards.forEach(c => c.buttons.splice(i, 1));
    },

    // ---- canvas ----------------------------------------------------------
    toCanvas(ev) {
      const r = this.$refs.canvas.getBoundingClientRect();
      return {
        x: (ev.clientX - r.left - this.pan.x) / this.zoom,
        y: (ev.clientY - r.top - this.pan.y) / this.zoom,
      };
    },
    onNodeDown(ev, n) {
      if (ev.button !== 0) return;
      ev.stopPropagation();
      this.selectedId = n.id;
      const p = this.toCanvas(ev);
      this.drag = { id: n.id, dx: p.x - n.x, dy: p.y - n.y };
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    },
    onPortDown(ev, n, i) {
      ev.stopPropagation();
      const p = this.toCanvas(ev);
      this.linking = { from: n.id, port: i, x: p.x, y: p.y };
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    },
    onCanvasDown(ev) {
      if (ev.target.closest('.fnode')) return;
      this.selectedId = null;
      this.panning = { x: ev.clientX - this.pan.x, y: ev.clientY - this.pan.y };
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    },
    onMove(ev) {
      if (this.drag) {
        const p = this.toCanvas(ev);
        const n = this.nodeById[this.drag.id];
        if (n) {
          n.x = Math.round((p.x - this.drag.dx) / 10) * 10;   // encaixa na grade
          n.y = Math.round((p.y - this.drag.dy) / 10) * 10;
        }
      } else if (this.linking) {
        const p = this.toCanvas(ev);
        this.linking.x = p.x; this.linking.y = p.y;
      } else if (this.panning) {
        this.pan.x = ev.clientX - this.panning.x;
        this.pan.y = ev.clientY - this.panning.y;
      }
    },
    onUp(ev) {
      if (this.linking) {
        const el = document.elementFromPoint(ev.clientX, ev.clientY);
        const card = el && el.closest ? el.closest('.fnode') : null;
        const targetId = card ? card.getAttribute('data-id') : null;
        const from = this.nodeById[this.linking.from];
        if (from && targetId && targetId !== from.id) {
          this.setPort(from, this.linking.port, targetId);
        }
      }
      this.drag = null; this.panning = null; this.linking = null;
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
    },
    onWheel(ev) {
      ev.preventDefault();
      this.zoomBy(ev.deltaY < 0 ? 1.1 : 0.9);
    },
    /* Zoom pelo centro da área visível: sem isto o desenho "foge" para o canto
       toda vez que aproxima. */
    zoomBy(factor) {
      const el = this.$refs.canvas;
      const w = el ? el.clientWidth : 800;
      const h = el ? el.clientHeight : 460;
      const next = Math.min(2, Math.max(0.3, this.zoom * factor));
      const k = next / this.zoom;
      this.pan.x = w / 2 - (w / 2 - this.pan.x) * k;
      this.pan.y = h / 2 - (h / 2 - this.pan.y) * k;
      this.zoom = next;
    },
    /* Enquadra o roteiro inteiro na tela — indispensável quando o fluxo cresce. */
    fitView() {
      if (!this.nodes.length) return;
      const el = this.$refs.canvas;
      const w = el ? el.clientWidth : 800;
      const h = el ? el.clientHeight : 460;
      const xs = this.nodes.map(n => n.x);
      const ys = this.nodes.map(n => n.y);
      const minX = Math.min(...xs);
      const minY = Math.min(...ys);
      const maxX = Math.max(...xs) + NODE_W;
      const maxY = Math.max(...ys) + NODE_H + 30;
      const pad = 60;
      const z = Math.min(1.4, Math.max(0.3,
        Math.min((w - pad * 2) / (maxX - minX), (h - pad * 2) / (maxY - minY))));
      this.zoom = z;
      this.pan.x = (w - (maxX - minX) * z) / 2 - minX * z;
      this.pan.y = (h - (maxY - minY) * z) / 2 - minY * z;
    },
    linkPath() {
      const l = this.linking;
      const from = this.nodeById[l.from];
      if (!from) return '';
      const a = this.portPos(from, l.port, this.portsOf(from).length);
      return `M ${a.x} ${a.y} L ${l.x} ${l.y}`;
    },

    // ---- simulador -------------------------------------------------------
    /* Roda o roteiro aqui mesmo, sem publicar nada — mesma lógica do motor do
       servidor, para conferir o caminho antes de colocar no ar. */
    startSim() {
      this.sim = { log: [], node: null, done: false };
      this.simRun(this.start, {});
    },
    simRun(id, vars) {
      let cur = id;
      let guard = 0;
      while (cur && guard < 25) {
        guard += 1;
        const n = this.nodeById[cur];
        if (!n) break;
        if (n.text) this.sim.log.push({ who: 'bot', text: this.simText(n.text, vars) });
        if (n.type === 'message') { cur = n.next; continue; }
        if (n.type === 'delay') {
          this.sim.log.push({ who: 'sys', text: `⏳ digitando por ${n.seconds || 2}s` });
          cur = n.next; continue;
        }
        if (n.type === 'image') {
          this.sim.log.push({ who: 'sys', text: `🖼️ imagem: ${n.src || '(sem URL)'}` });
          cur = n.next; continue;
        }
        if (n.type === 'link') {
          this.sim.log.push({ who: 'bot', text: `🔗 ${n.label || 'Abrir'} → ${this.simText(n.url, vars)}` });
          cur = n.next; continue;
        }
        if (n.type === 'condition') { cur = vars[n.var] ? n.next : n.else; continue; }
        if (n.type === 'list') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'carousel') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'buttons') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'input') { this.sim.node = { ...n, vars }; this.simFocus(); return; }
        if (n.type === 'splash') { this.sim.log.push({ who: 'sys', text: `✨ destaque: ${n.titulo || '(sem título)'}${n.midia ? ' + mídia' : ''}` }); cur = n.next; continue; }
        if (n.type === 'http') { this.sim.log.push({ who: 'sys', text: `🌐 HTTP ${n.metodo || 'GET'} → salva em {{${n.salvar_em || 'resposta'}}} (use ▶ Testar p/ rodar de verdade)` }); cur = n.next; continue; }
        if (n.type === 'supabase') { this.sim.log.push({ who: 'sys', text: `🗄️ Supabase ${n.op || 'inserir'} em ${n.tabela || '(tabela)'} (use ▶ Testar p/ rodar de verdade)` }); cur = n.next; continue; }
        if (n.type === 'script') { this.sim.log.push({ who: 'sys', text: `🐍 Script → salva em {{${n.salvar_em || 'saida'}}} (use ▶ Testar p/ rodar de verdade)` }); cur = n.next; continue; }
        if (n.type === 'oferta') {
          const quais = (n.bancos || []).length ? n.bancos.join(', ') : 'todos os bancos liberados';
          this.sim.log.push({ who: 'sys', text: `💰 consulta oferta em ${quais} (até ${n.teto_s || OFERTA_TETO_PADRAO}s) → salva em {{${n.salvar_em || 'ofertas'}}}. Aqui o teste segue pela saída "achou oferta".` });
          cur = n.next; continue;
        }
        if (n.type === 'ofertas') { this.sim.log.push({ who: 'sys', text: '🏷️ mostra os cards das ofertas encontradas e espera o cliente escolher' }); cur = n.next; continue; }
        if (n.type === 'bot') {
          // A fala (n.text) já foi para o log lá em cima, junto com a de
          // qualquer outro bloco — aqui entra só o que a transferência faz.
          this.sim.log.push({ who: 'sys', text: `🤖 entrega a conversa para a IA ${n.bot_id || '(padrão)'} e manda o gatilho “${this.simText(n.gatilho, vars) || '(padrão)'}”. Aqui o teste segue pela saída, como se tivesse dado certo.` });
          cur = n.next; continue;
        }
        if (n.type === 'ai') { this.sim.log.push({ who: 'sys', text: '→ IA assume a conversa' }); break; }
        if (n.type === 'agent') { this.sim.log.push({ who: 'sys', text: '→ atendente humano assume' }); break; }
        if (n.type === 'end') { this.sim.log.push({ who: 'sys', text: '→ roteiro encerrado' }); break; }
        break;
      }
      this.sim.node = null;
      this.sim.done = true;
      this.simFocus();
    },
    simText(t, vars) {
      return String(t || '').replace(/\{\{\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*\}\}/g, (m, k) => vars[k] || '');
    },
    simPick(opt) {
      const n = this.sim.node;
      const vars = { ...n.vars };
      // Grava o valor interno quando existe — igual ao motor do servidor.
      if (n.field) vars[n.field] = opt.value || opt.label;
      this.sim.log.push({ who: 'cli', text: opt.echo || opt.label });
      this.sim.node = null;
      this.simRun(opt.next, vars);
    },
    /* Escolhas do passo atual, na MESMA ordem que o servidor usa (botões de
       link não entram, porque abrem numa aba e não avançam o roteiro). */
    simChoices(n) {
      if (!n) return [];
      if (n.type === 'carousel') {
        const out = [];
        (n.cards || []).forEach(c => {
          (c.buttons || []).forEach(b => {
            if (b.url) return;
            out.push({ ...b, echo: `${c.title || 'card'} — ${b.label}` });
          });
        });
        return out;
      }
      return (n.options || []).filter(o => !o.url);
    },
    simSend(value) {
      const n = this.sim.node;
      const vars = { ...n.vars };
      if (!this.simValid(n.validate, value)) {
        this.sim.log.push({ who: 'cli', text: value });
        this.sim.log.push({ who: 'bot', text: n.error || 'Não consegui validar. Confere pra mim?' });
        this.simFocus();
        return;
      }
      vars[n.field || 'resposta'] = value;
      this.sim.log.push({ who: 'cli', text: value });
      this.sim.node = null;
      this.simRun(n.next, vars);
    },
    simValid(kind, v) {
      v = (v || '').trim();
      if (kind === 'cpf') {
        const c = v.replace(/\D/g, '');
        if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
        let t = 0;
        for (let i = 0; i < 9; i += 1) t += parseInt(c[i], 10) * (10 - i);
        let r = t % 11;
        if (parseInt(c[9], 10) !== (r < 2 ? 0 : 11 - r)) return false;
        t = 0;
        for (let i = 0; i < 10; i += 1) t += parseInt(c[i], 10) * (11 - i);
        r = t % 11;
        return parseInt(c[10], 10) === (r < 2 ? 0 : 11 - r);
      }
      if (kind === 'email') return /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/.test(v);
      if (kind === 'telefone') { const d = v.replace(/\D/g, ''); return d.length === 10 || d.length === 11; }
      if (kind === 'numero') return /\d/.test(v);
      return v.length > 0;
    },
  },
};
</script>

<template>
  <div class="mx-6">
    <h3 v-if="!embedded" class="text-base font-semibold mb-1">Fluxo de atendimento</h3>
    <p v-if="!embedded" class="text-sm text-slate-500 dark:text-slate-400 mb-4">
      Monte o roteiro que o cliente vê ao abrir o site: mensagem, botões e coleta de
      dados com validação. Quando o cliente perguntar algo fora do roteiro, a conversa
      passa para a IA automaticamente, com todo o histórico.
    </p>

    <label style="display:flex;align-items:center;gap:8px;cursor:pointer" class="mb-2">
      <input v-model="enabled" type="checkbox" style="margin:0" />
      <span class="text-sm font-medium">Ativar este roteiro</span>
      <span class="px-2 py-0.5 text-xs font-semibold rounded-full"
            :style="enabled ? 'background:rgba(0,168,132,.18);color:#0f7c63'
                            : 'background:rgba(148,163,184,.2)'">
        {{ enabled ? 'roteiro conduz a conversa' : 'roteiro desligado' }}
      </span>
    </label>
    <p v-if="embedded" class="mb-4 text-xs text-slate-500">
      Com o roteiro ligado, ele conduz e só passa para a IA nos blocos
      "Passar para IA". Desligado, quem responde é a IA padrão da caixa.
    </p>
    <p v-if="!embedded && !enabled" class="text-xs text-slate-500 mb-4">
      Desligado, a caixa segue como hoje: saudação automática e IA respondendo tudo.
    </p>

    <div v-if="!embedded" class="p-4 mb-4 rounded-lg" style="background:rgba(148,163,184,.08)">
      <p class="mb-1 text-sm font-semibold">🤖 IA desta caixa</p>
      <p class="mb-3 text-xs text-slate-500">
        Usada no bloco "Passar para IA" e quando o cliente perguntar algo fora do
        roteiro. Cada caixa tem a sua chave — assim dá para separar o custo e
        revogar uma sem afetar as outras.
      </p>
      <div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">
        <select v-model="iaModelo" style="max-width:190px">
          <option v-for="m in modelos" :key="m" :value="m">{{ m }}</option>
        </select>
        <input v-model="iaChave" type="password" autocomplete="new-password"
               :placeholder="iaTemChave ? `Chave salva (${iaDica}) — digite para trocar` : 'Chave da OpenAI (sk-…)'"
               style="flex:1;min-width:240px" />
        <button type="button" class="text-xs px-3 py-1 rounded"
                style="background:#00a884;color:#fff" :disabled="iaSalvando"
                @click="salvarIa">{{ iaSalvando ? 'Salvando…' : 'Salvar IA' }}</button>
      </div>
      <p class="mt-2 text-xs text-slate-500">
        A chave é gravada fora da configuração da caixa e <b>nunca volta para a
        tela</b> — por isso só aparece o final dela.
      </p>
    </div>

    <p class="text-xs text-slate-500 mb-2">
      Arraste os blocos · ligue arrastando a bolinha de baixo · Esc sai da tela cheia
    </p>

    <!-- Botão de sair da tela cheia: vermelho com X branco, no topo. -->
    <button v-if="full" type="button" class="fclose" title="Fechar tela cheia (Esc)" @click="toggleFull">
      ✕
    </button>

    <div
      ref="canvas"
      class="fcanvas rounded-lg"
      :class="{ 'is-full': full }"
      @pointerdown="onCanvasDown"
      @wheel="onWheel"
    >
      <!-- Barra flutuante: fica DENTRO do canvas para continuar acessível em
           tela cheia (antes ela vivia acima e sumia ao ampliar). -->
      <div class="ftoolbar" @pointerdown.stop>
        <!-- Fileira 1: os blocos que se arrasta para o canvas. -->
        <div class="ftrow is-palette">
          <button
            v-for="t in types" :key="t.type" type="button"
            class="ftool is-block" :title="t.hint" @click="addNode(t.type)"
          ><span class="ftool-ico">{{ t.icon }}</span>{{ t.label }}</button>
        </div>

        <!-- Fileira 2: controles, agrupados por função e com cor própria para
             não sumirem no fundo escuro. -->
        <div class="ftrow is-ctl">
          <div class="fgrp">
            <button class="ftool is-icon" type="button" title="Afastar" @click="zoomBy(0.85)">−</button>
            <span class="fzoom-val">{{ Math.round(zoom * 100) }}%</span>
            <button class="ftool is-icon" type="button" title="Aproximar" @click="zoomBy(1.18)">+</button>
            <button class="ftool" type="button" title="Enquadrar o roteiro" @click="fitView">Ajustar</button>
            <button class="ftool" type="button" title="Separa os blocos na ordem da conversa" @click="organizar">
              ⌗ Organizar
            </button>
          </div>

          <div class="fgrp">
            <button class="ftool is-test" type="button" @click="startSim">▶ Testar</button>
            <button class="ftool is-view" type="button" @click="toggleFull">
              {{ full ? '⤡ Reduzir' : '⛶ Ampliar' }}
            </button>
          </div>

          <!-- Modelos: salvar o roteiro da tela e reusar em outra caixa. -->
          <div class="fgrp is-tpl">
            <span class="fgrp-tag">Modelos</span>
            <select v-model="tplSel" class="ftool-sel" title="Modelos salvos">
              <option value="">— escolher —</option>
              <option v-for="t in templates" :key="t.id" :value="t.id">{{ t.nome }}</option>
            </select>
            <button class="ftool is-use" type="button" title="Carregar o modelo escolhido"
                    :disabled="!tplSel" @click="usarTemplate">Usar</button>
            <button class="ftool is-icon is-del" type="button" title="Excluir o modelo escolhido"
                    :disabled="!tplSel" @click="excluirTemplate">🗑</button>
            <button class="ftool is-save" type="button" title="Salvar este roteiro como modelo"
                    @click="salvarTemplate">💾 Salvar template</button>
          </div>
        </div>
      </div>

      <div :style="{transform:`translate(${pan.x}px,${pan.y}px) scale(${zoom})`,transformOrigin:'0 0',position:'absolute',inset:0}">
        <svg style="position:absolute;overflow:visible;width:1px;height:1px">
          <g v-for="e in edges" :key="e.key" class="fedge-g">
            <!-- trilho grosso e invisível: dá área de mouse na curva fina -->
            <path :d="e.d" class="fedge-hit" fill="none" stroke-width="16" />
            <path :d="e.d" class="fedge" fill="none" stroke-width="2" />
            <g class="fedge-del" :transform="`translate(${e.mid.x},${e.mid.y})`"
               @pointerdown.stop.prevent="removeEdge(e)">
              <title>Desfazer esta ligação</title>
              <circle r="10" />
              <path d="M -3.2 -3.2 L 3.2 3.2 M 3.2 -3.2 L -3.2 3.2" />
            </g>
          </g>
          <path v-if="linking" :d="linkPath()" fill="none" stroke="#00a884"
                stroke-width="2.5" stroke-dasharray="5 4" style="pointer-events:none" />
        </svg>

        <div
          v-for="n in nodes" :key="n.id"
          class="fnode" :data-id="n.id"
          :style="{position:'absolute',left:n.x+'px',top:n.y+'px',width:'210px',minHeight:'92px'}"
          @pointerdown="onNodeDown($event, n)"
        >
          <div class="fcard" :class="{ 'is-selected': selectedId === n.id }">
            <div class="fcard-head">
              <span>{{ iconOf(n) }} {{ (types.find(t=>t.type===n.type)||{}).label }}</span>
              <span v-if="start===n.id" class="fcard-start">início</span>
            </div>
            <div class="fcard-text">{{ (n.text || '—').slice(0, 70) }}</div>
            <div v-if="n.type==='buttons' || n.type==='list'" class="fcard-chips">
              <span v-for="(o,i) in n.options" :key="i" class="fchip">{{ o.url ? '🔗 ' : '' }}{{ o.label }}</span>
            </div>
            <div v-if="n.type==='carousel'" class="fcard-chips">
              <span v-for="(c,i) in n.cards" :key="i" class="fchip">{{ c.title || ('card ' + (i+1)) }}</span>
            </div>
            <div v-if="n.type==='input'" class="fcard-meta">
              valida: {{ n.validate }} → {{ n.field }}
            </div>
            <div v-if="n.type==='ai'" class="fcard-meta">
              🤖 {{ (agentesIa.find(a => a.id === n.agent) || {}).nome || 'IA padrão' }}
            </div>
            <div v-if="n.type==='link'" class="fcard-meta">🔗 {{ n.label || 'Abrir' }}</div>
            <div v-if="n.type==='delay'" class="fcard-meta">⏳ {{ n.seconds || 2 }}s</div>
            <div v-if="n.type==='oferta'" class="fcard-meta">
              💰 {{ (n.bancos || []).length ? n.bancos.join(', ') : 'todos os bancos' }} · até {{ n.teto_s || 25 }}s
            </div>
            <div v-if="n.type==='ofertas'" class="fcard-meta">🏷️ cards das ofertas encontradas</div>
            <div v-if="n.type==='bot'" class="fcard-meta">
              🤖 IA {{ n.bot_id || 'padrão' }} · “{{ (n.gatilho || 'gatilho padrão').slice(0, 28) }}”
            </div>
          </div>
          <!-- saídas -->
          <div
            v-for="(p,i) in portsOf(n)" :key="i"
            class="fport" :class="{ 'is-linked': !!p.next }"
            :style="{left:(210/(portsOf(n).length+1)*(i+1)-6)+'px'}"
            :title="p.label ? ('saída: '+p.label) : 'saída'"
            @pointerdown="onPortDown($event, n, i)"
          />
        </div>
      </div>
    </div>

    <!-- painel do bloco selecionado -->
    <div v-if="selected" class="fpanel mt-4 p-4 rounded-lg" :class="{ 'is-full': full }">
      <div style="display:flex;justify-content:space-between;align-items:center" class="mb-3">
        <span class="text-sm font-semibold">{{ iconOf(selected) }} {{ (types.find(t=>t.type===selected.type)||{}).label }}</span>
        <span style="display:flex;gap:8px">
          <button type="button" class="text-xs" style="color:#00a884" @click="start = selected.id">definir como início</button>
          <button type="button" class="text-xs" style="color:#f15c6d" @click="removeNode(selected.id)">excluir</button>
        </span>
      </div>

      <label class="block text-xs font-medium mb-1">Mensagem</label>
      <textarea v-model="selected.text" rows="2" class="mb-3"
                placeholder="O que a Julia fala neste passo. Use {{cpf}} para inserir o que já foi coletado."></textarea>

      <template v-if="selected.type==='buttons' || selected.type==='list'">
        <label class="block text-xs font-medium mb-1">
          {{ selected.type === 'list' ? 'Itens da lista' : 'Botões' }}
          <span class="text-slate-500">(máx. {{ maxOptions(selected) }})</span>
        </label>
        <div v-for="(o,i) in selected.options" :key="i" class="p-2 mb-2 rounded" style="background:rgba(148,163,184,.08)">
          <div style="display:flex;gap:6px" class="mb-1">
            <input v-model="o.label" type="text"
                   :maxlength="selected.type==='list' ? 24 : 20"
                   :placeholder="selected.type==='list' ? 'Título do item' : 'Texto do botão'" />
            <button type="button" class="text-xs" style="color:#f15c6d"
                    @click="selected.options.splice(i,1)">remover</button>
          </div>
          <input v-if="selected.type==='list'" v-model="o.description" type="text" maxlength="72"
                 placeholder="Descrição (opcional)" class="mb-1" />
          <input v-model="o.value" type="text" maxlength="60"
                 placeholder="Valor interno (opcional) — ex.: OF_12X" />
          <input v-if="selected.type==='buttons'" v-model="o.url" type="text"
                 placeholder="Link (opcional) — https://…" class="mt-1" />
          <p v-if="selected.type==='buttons' && o.url" class="text-xs text-slate-500 mt-1">
            Com link preenchido esta opção vira um <b>botão que abre o link</b> em
            outra aba: ela não avança o roteiro e por isso não tem saída no desenho.
          </p>
        </div>
        <button type="button" class="text-xs mb-2" style="color:#00a884"
                :disabled="selected.options.length >= maxOptions(selected)"
                @click="addOption(selected)">+ adicionar</button>
        <p class="text-xs text-slate-500 mb-3">
          O <b>valor interno</b> é o que fica guardado; o texto é só o que o cliente lê.
          Assim dá para mudar o rótulo sem quebrar as condições do roteiro.
          <template v-if="selected.type==='buttons'">
            Deixe o <b>link</b> vazio para o botão seguir o roteiro; preenchido, ele
            só abre o endereço (serve, por exemplo, para mandar o cliente ao WhatsApp).
          </template>
        </p>
        <template v-if="selected.type==='list'">
          <label class="block text-xs font-medium mb-1">Texto do botão que abre a lista</label>
          <input v-model="selected.button" type="text" maxlength="20" placeholder="Ver opções" class="mb-2" />
        </template>
        <label class="block text-xs font-medium mb-1">Guardar a escolha em (opcional)</label>
        <input v-model="selected.field" type="text" placeholder="ex.: produto" class="mb-2" />
        <label v-if="channel !== 'whatsapp'" style="display:flex;align-items:center;gap:8px;cursor:pointer" class="mb-2">
          <input v-model="selected.allow_text" type="checkbox" style="margin:0" />
          <span class="text-xs">Permitir que o cliente digite em vez de clicar (a pergunta livre vai para a IA)</span>
        </label>
        <p v-else class="text-xs text-slate-500 mb-2">
          No WhatsApp o cliente sempre pode digitar — a pergunta livre vai para a IA.
        </p>
      </template>

      <template v-if="selected.type==='carousel'">
        <p class="text-xs text-slate-500 mb-2">
          De 2 a 10 cards. Todos os cards têm os <b>mesmos botões</b> — é regra do
          WhatsApp e evita cards de alturas diferentes.
        </p>
        <div v-for="(c,ci) in selected.cards" :key="ci" class="p-2 mb-2 rounded" style="background:rgba(148,163,184,.08)">
          <div style="display:flex;gap:6px;align-items:center" class="mb-1">
            <b class="text-xs">Card {{ ci + 1 }}</b>
            <button v-if="selected.cards.length > 2" type="button" class="text-xs" style="color:#f15c6d"
                    @click="selected.cards.splice(ci,1)">remover</button>
          </div>
          <input v-model="c.title" type="text" maxlength="60" placeholder="Título — ex.: R$ 1.847" class="mb-1" />
          <input v-model="c.body" type="text" maxlength="160" placeholder="Descrição — ex.: em 12x de R$ 180" class="mb-1" />
          <input v-model="c.image" type="text" placeholder="URL da imagem (opcional)" class="mb-1" />
          <div v-for="(b,bi) in c.buttons" :key="bi" style="display:flex;gap:6px" class="mb-1">
            <input v-model="b.label" type="text" maxlength="20" placeholder="Botão" />
            <input v-model="b.value" type="text" maxlength="60" placeholder="Valor interno" />
            <input v-model="b.url" type="text" placeholder="URL (deixe vazio p/ seguir o roteiro)" />
          </div>
        </div>
        <div style="display:flex;gap:12px" class="mb-3">
          <button type="button" class="text-xs" style="color:#00a884"
                  :disabled="selected.cards.length >= 10" @click="addCard(selected)">+ card</button>
          <button type="button" class="text-xs" style="color:#00a884"
                  :disabled="!selected.cards.length || selected.cards[0].buttons.length >= 2"
                  @click="addCardButton(selected)">+ botão em todos</button>
          <button v-if="selected.cards.length && selected.cards[0].buttons.length > 1"
                  type="button" class="text-xs" style="color:#f15c6d"
                  @click="removeCardButton(selected, selected.cards[0].buttons.length - 1)">− botão</button>
        </div>
        <label class="block text-xs font-medium mb-1">Guardar a escolha em (opcional)</label>
        <input v-model="selected.field" type="text" placeholder="ex.: oferta" class="mb-2" />
      </template>

      <template v-if="selected.type==='link'">
        <label class="block text-xs font-medium mb-1">Endereço (URL)</label>
        <input v-model="selected.url" type="text" placeholder="https://… (aceita {{variavel}})" class="mb-2" />
        <label class="block text-xs font-medium mb-1">Texto do botão</label>
        <input v-model="selected.label" type="text" maxlength="20" placeholder="Assinar agora" class="mb-2" />
        <p class="text-xs text-slate-500">O link abre em outra aba e o roteiro continua.</p>
      </template>

      <template v-if="selected.type==='image'">
        <label class="block text-xs font-medium mb-1">URL da imagem</label>
        <input v-model="selected.src" type="text" placeholder="https://…" class="mb-2" />
        <p class="text-xs text-slate-500">A mensagem acima vira a legenda.</p>
      </template>

      <template v-if="selected.type==='delay'">
        <label class="block text-xs font-medium mb-1">Segundos de "digitando…"</label>
        <input v-model.number="selected.seconds" type="number" min="0.2" max="10" step="0.5"
               style="max-width:120px" class="mb-2" />
        <p class="text-xs text-slate-500">
          Dá naturalidade depois de uma consulta. Entre 0,2 e 10 segundos.
        </p>
      </template>

      <template v-if="selected.type==='input'">
        <label class="block text-xs font-medium mb-1">O que pedir</label>
        <select v-model="selected.validate" class="mb-2" style="max-width:220px">
          <option value="cpf">CPF (valida na hora)</option>
          <option value="telefone">Telefone</option>
          <option value="email">E-mail</option>
          <option value="numero">Número</option>
          <option value="texto">Texto livre</option>
        </select>
        <label class="block text-xs font-medium mb-1">Guardar em</label>
        <input v-model="selected.field" type="text" placeholder="ex.: cpf" class="mb-2" />
        <label class="block text-xs font-medium mb-1">Mensagem quando não validar</label>
        <input v-model="selected.error" type="text" placeholder="Esse CPF não confere. Pode revisar?" class="mb-2" />
      </template>

      <template v-if="selected.type==='condition'">
        <label class="block text-xs font-medium mb-1">Variável</label>
        <input v-model="selected.var" type="text" placeholder="ex.: cpf" class="mb-2" />
        <label class="block text-xs font-medium mb-1">Condição</label>
        <select v-model="selected.op" class="mb-2" style="max-width:220px">
          <option value="preenchido">está preenchida</option>
          <option value="igual">é igual a</option>
          <option value="contem">contém</option>
        </select>
        <input v-if="selected.op!=='preenchido'" v-model="selected.value" type="text" placeholder="valor" class="mb-2" />
        <p class="text-xs text-slate-500">A primeira saída é o "sim", a segunda é o "não".</p>
      </template>

      <template v-if="selected.type==='ai'">
        <label class="block text-xs font-medium mb-1">Qual IA atende a partir daqui</label>
        <select v-model="selected.agent" class="mb-2" style="max-width:280px">
          <option value="">A IA padrão da caixa</option>
          <option v-for="a in agentesIa" :key="a.id" :value="a.id">{{ a.nome || a.id }}</option>
        </select>
        <p v-if="!agentesIa.length" class="text-xs text-slate-500">
          Nenhuma IA criada ainda — crie na aba "As IAs". Sem IA, este bloco
          encerra o roteiro e a conversa fica para um atendente.
        </p>
      </template>

      <template v-if="selected.type==='agent'">
        <label class="block text-xs font-medium mb-1">Etiqueta a aplicar (opcional)</label>
        <input v-model="selected.label" type="text" placeholder="ex.: atendimento_humano" class="mb-2" />
      </template>

      <!-- ============ HTTP (estilo n8n) ============ -->
      <template v-if="selected.type==='http'">
        <div class="fhelp">Chama uma API e salva a resposta em variáveis. Use <code>&#123;&#123;cpf&#125;&#125;</code> nos campos e <code>&#123;&#123;secret:NOME&#125;&#125;</code> para credenciais.</div>
        <div class="flex gap-2 mb-2">
          <select v-model="selected.metodo" style="max-width:110px">
            <option>GET</option><option>POST</option><option>PUT</option><option>PATCH</option><option>DELETE</option>
          </select>
          <input v-model="selected.url" type="text" placeholder="https://api.exemplo.com/consulta" class="flex-1" />
        </div>
        <label class="block text-xs font-medium mb-1">Headers</label>
        <div v-for="(h,i) in selected.headers" :key="'h'+i" class="flex gap-2 mb-1">
          <input v-model="h.chave" type="text" placeholder="Authorization" class="flex-1" />
          <input v-model="h.valor" type="text" placeholder="Bearer &#123;&#123;secret:token&#125;&#125;" class="flex-1" />
          <button type="button" class="fx" @click="selected.headers.splice(i,1)">✕</button>
        </div>
        <button type="button" class="fadd mb-2" @click="selected.headers.push({chave:'',valor:''})">＋ header</button>

        <label class="block text-xs font-medium mb-1">Query (?a=b)</label>
        <div v-for="(q,i) in selected.query" :key="'q'+i" class="flex gap-2 mb-1">
          <input v-model="q.chave" type="text" placeholder="cpf" class="flex-1" />
          <input v-model="q.valor" type="text" placeholder="&#123;&#123;cpf&#125;&#125;" class="flex-1" />
          <button type="button" class="fx" @click="selected.query.splice(i,1)">✕</button>
        </div>
        <button type="button" class="fadd mb-2" @click="selected.query.push({chave:'',valor:''})">＋ query</button>

        <label class="block text-xs font-medium mb-1">Corpo</label>
        <select v-model="selected.body_modo" class="mb-1" style="max-width:160px">
          <option value="none">Sem corpo</option><option value="json">JSON</option><option value="raw">Texto</option>
        </select>
        <textarea v-if="selected.body_modo!=='none'" v-model="selected.body" rows="4"
          placeholder='{"cpf":"{{cpf}}"}' class="mb-2 font-mono" />

        <label class="block text-xs font-medium mb-1">Salvar campos da resposta em variáveis</label>
        <div v-for="(m,i) in selected.mapear" :key="'m'+i" class="flex gap-2 mb-1">
          <input v-model="m.campo" type="text" placeholder="campo do JSON" class="flex-1" />
          <span class="text-xs self-center">→</span>
          <input v-model="m.var" type="text" placeholder="variável" class="flex-1" />
          <button type="button" class="fx" @click="selected.mapear.splice(i,1)">✕</button>
        </div>
        <button type="button" class="fadd mb-2" @click="selected.mapear.push({campo:'',var:''})">＋ campo</button>

        <div class="flex gap-2 items-center mb-2">
          <label class="text-xs">Timeout (s)</label>
          <input v-model.number="selected.timeout_seg" type="number" min="3" max="30" style="max-width:80px" />
          <label class="text-xs ml-2">Guardar tudo em</label>
          <input v-model="selected.salvar_em" type="text" placeholder="resposta" class="flex-1" />
        </div>
        <button type="button" class="ftest" :disabled="acaoTestando" @click="testarAcao(selected)">
          {{ acaoTestando ? 'Testando…' : '▶ Testar requisição' }}
        </button>
        <pre v-if="acaoResultado" class="fresult">{{ acaoResultado }}</pre>
      </template>

      <!-- ============ Supabase ============ -->
      <template v-if="selected.type==='supabase'">
        <div class="fhelp">Salva ou consulta o atendimento no banco. Só tabelas liberadas nesta caixa aparecem.</div>
        <div class="flex gap-2 mb-2">
          <select v-model="selected.op" style="max-width:130px">
            <option value="inserir">Inserir</option><option value="consultar">Consultar</option>
          </select>
          <select v-model="selected.tabela" class="flex-1">
            <option value="">— escolha a tabela —</option>
            <option v-for="t in sbTabelas" :key="t" :value="t">{{ t }}</option>
          </select>
          <button type="button" class="fadd" :disabled="sbCarregando" @click="carregarTabelas(selected.tabela)">
            {{ sbCarregando ? '…' : '↻' }}
          </button>
        </div>
        <p v-if="!sbTabelas.length" class="fhelp">Nenhuma tabela liberada. Libere na aba (Segredos & Supabase) e clique ↻.</p>

        <label class="block text-xs font-medium mb-1">
          {{ selected.op==='inserir' ? 'Colunas a gravar (o valor aceita variáveis)' : 'Filtros (coluna = valor)' }}
        </label>
        <textarea :value="kvText(selected.op==='inserir' ? selected.valores : selected.filtros)"
          rows="4" class="mb-1 font-mono" placeholder="coluna=valor por linha"
          @input="setKv(selected, selected.op==='inserir' ? 'valores' : 'filtros', $event.target.value)" />
        <p v-if="sbColunas.length" class="fhelp">Colunas: {{ sbColunas.join(', ') }}</p>

        <div class="flex gap-2 items-center mb-2">
          <template v-if="selected.op==='consultar'">
            <label class="text-xs">Limite</label>
            <input v-model.number="selected.limit" type="number" min="1" max="100" style="max-width:80px" />
          </template>
          <label class="text-xs ml-1">Salvar resultado em</label>
          <input v-model="selected.salvar_em" type="text" placeholder="consulta" class="flex-1" />
        </div>
        <button type="button" class="ftest" :disabled="acaoTestando || !selected.tabela" @click="testarAcao(selected)">
          {{ acaoTestando ? 'Testando…' : '▶ Testar no banco' }}
        </button>
        <pre v-if="acaoResultado" class="fresult">{{ acaoResultado }}</pre>
      </template>

      <!-- ============ Destaque (splash) ============ -->
      <template v-if="selected.type==='splash'">
        <div class="fhelp">
          Estoura na tela do cliente por cima da conversa. Aceita <b>imagem</b>,
          <b>vídeo</b> (link .mp4) ou <b>YouTube</b>. Só vale no webchat — no
          WhatsApp este bloco é ignorado.
        </div>
        <label class="block text-xs font-medium mb-1">Título</label>
        <input v-model="selected.titulo" type="text" maxlength="80"
               placeholder="Novidade!" class="mb-2" />
        <label class="block text-xs font-medium mb-1">
          Imagem, vídeo ou link do YouTube (opcional)
        </label>
        <input v-model="selected.midia" type="text"
               placeholder="https://… .jpg / .mp4 / youtube.com/watch?v=…" class="mb-1" />
        <div v-if="selected.midia" class="fsplash-prev mb-2">
          <img v-if="!ehVideo(selected.midia)" :src="selected.midia" alt="" @error="$event.target.style.display='none'" />
          <p v-else class="fhelp" style="margin:0">▶ vídeo — aparece com player na conversa</p>
        </div>

        <label class="block text-xs font-medium mb-1">Botões (até 3)</label>
        <div v-for="(b,i) in selected.botoes" :key="'sb'+i" class="flex gap-2 mb-1">
          <input v-model="b.label" type="text" maxlength="24" placeholder="IR PARA O SITE" style="max-width:150px" />
          <input v-model="b.url" type="text" placeholder="https://… (vazio = só fecha)" class="flex-1" />
          <button type="button" class="fx" @click="selected.botoes.splice(i,1)">✕</button>
        </div>
        <button v-if="selected.botoes.length < 3" type="button" class="fadd mb-2"
                @click="selected.botoes.push({label:'',url:''})">＋ botão</button>
        <p class="fhelp">
          Botão sem link fecha o destaque (ex.: “OK”). Com link, abre em outra aba
          — serve para site, Instagram, WhatsApp, o que você quiser.
        </p>
      </template>

      <!-- ============ Script Python (isolado) ============ -->
      <template v-if="selected.type==='script'">
        <div class="fhelp">Roda Python <b>isolado</b>: sem internet e sem os segredos do sistema. Use <code>vars</code> (dicionário do fluxo); o que você puser em <code>vars</code> volta pro roteiro. Para API/banco use os blocos HTTP/Supabase.</div>
        <label class="block text-xs font-medium mb-1">Código Python</label>
        <textarea v-model="selected.code" rows="8" class="mb-2 font-mono" spellcheck="false" />
        <label class="block text-xs font-medium mb-1">Variáveis do cabeçalho (.env) — chave=valor por linha</label>
        <textarea :value="kvText(selected.env)" rows="3" class="mb-1 font-mono"
          placeholder="TAXA=1.8&#10;ORIGEM=&#123;&#123;produto&#125;&#125;"
          @input="setKv(selected, 'env', $event.target.value)" />
        <div class="flex gap-2 items-center mb-2">
          <label class="text-xs">Salvar saída em</label>
          <input v-model="selected.salvar_em" type="text" placeholder="saida" class="flex-1" />
        </div>
        <button type="button" class="ftest" :disabled="acaoTestando" @click="testarAcao(selected)">
          {{ acaoTestando ? 'Testando…' : '▶ Testar script' }}
        </button>
        <pre v-if="acaoResultado" class="fresult">{{ acaoResultado }}</pre>
      </template>

      <!-- ============ Consultar oferta (bancos de verdade) ============ -->
      <template v-if="selected.type==='oferta'">
        <div class="fhelp">
          Consulta a oferta nos <b>bancos de verdade</b> com o CPF que o roteiro já
          coletou e <b>guarda o resultado</b> numa variável. Não mostra nada para o
          cliente: quem mostra é o bloco <b>Mostrar ofertas</b>, logo depois.
          A saída <b>“achou oferta”</b> segue quando algum banco respondeu com
          proposta; a saída <b>“não achou”</b> segue quando ninguém tinha nada.
        </div>
        <label class="block text-xs font-medium mb-1">Bancos a consultar</label>
        <div class="fbancos mb-1">
          <label v-for="b in bancosDisponiveis" :key="b.id" class="fbanco">
            <input type="checkbox" :value="b.id" v-model="selected.bancos" />
            <span>{{ b.nome }}</span>
          </label>
        </div>
        <p class="text-xs text-slate-500 mb-3">
          Nenhum marcado = consulta <b>todos</b> os bancos liberados nesta caixa.
          Quanto mais bancos, mais demora a resposta.
        </p>

        <div class="flex gap-2 items-center mb-1">
          <label class="text-xs">Esperar no máximo (segundos)</label>
          <input v-model.number="selected.teto_s" type="number" min="5" max="60" style="max-width:90px" />
        </div>
        <p class="text-xs text-slate-500 mb-3">
          Passou desse tempo, o roteiro segue com o que já chegou (de 5 a 60s; o
          normal é 25).
        </p>

        <label class="block text-xs font-medium mb-1">Guardar as ofertas em</label>
        <input v-model="selected.salvar_em" type="text" placeholder="ofertas" class="mb-1" />
        <p class="text-xs text-slate-500 mb-2">
          É o nome da variável que o bloco <b>Mostrar ofertas</b> lê. Só letras,
          números e “_”.
        </p>
      </template>

      <!-- ============ Transferir para IA (agent bot do Chatwoot) ============ -->
      <template v-if="selected.type==='bot'">
        <div class="fhelp">
          <b>Entrega a conversa</b> para uma IA que já atende no WhatsApp (ex.: a
          FGTS IA). O webchat faz as duas coisas que a transferência exige:
          <b>atribui a IA à conversa</b> — é o que faz as próximas mensagens do
          cliente chegarem nela — e <b>manda o gatilho</b> para ela começar agora.
          Diferente do bloco <b>Passar para IA</b>, que é a IA desta própria caixa.
        </div>

        <label class="block text-xs font-medium mb-1">Qual IA (número do agent bot)</label>
        <input v-model.number="selected.bot_id" type="number" min="1" max="999"
          placeholder="1" class="mb-1" style="max-width:120px" />
        <p class="text-xs text-slate-500 mb-3">
          É o número do <b>Agent Bot</b> no Chatwoot (a FGTS IA é a <b>1</b>).
          Em branco = a IA padrão configurada no servidor.
        </p>

        <label class="block text-xs font-medium mb-1">Webhook da IA</label>
        <input v-model="selected.url" type="text"
          placeholder="https://atendimento-ia.mazam.ai/fgts-ia/webhook/chatwoot" class="mb-1" />
        <p class="text-xs text-slate-500 mb-3">
          O mesmo endereço do campo <b>Outgoing URL</b> do bot no Chatwoot. Em
          branco = o padrão do servidor.
        </p>

        <label class="block text-xs font-medium mb-1">Gatilho (o que a IA recebe como se o cliente tivesse dito)</label>
        <input v-model="selected.gatilho" type="text"
          placeholder="Quero antecipar meu FGTS" class="mb-1" maxlength="300" />
        <p class="text-xs text-slate-500 mb-3">
          Frase natural que faz a IA começar já no assunto, em vez de saudar de
          novo. Aceita variáveis: <code>&#123;&#123;cpf&#125;&#125;</code>,
          <code>&#123;&#123;nome&#125;&#125;</code>…
        </p>

        <p class="text-xs text-slate-500 mb-2">
          O campo <b>Mensagem</b> lá em cima é opcional e é falado ao cliente
          <b>antes</b> da transferência (ex.: “vou te passar para a nossa
          especialista”): ela leva alguns segundos e, sem aviso, parece travada.
          Em branco = não fala nada.
        </p>

        <p class="text-xs text-slate-500 mb-2">
          Deu errado? O atendimento <b>não cai</b>: fica registrado em nota
          interna e o roteiro segue pela saída deste bloco. Para tratar a falha,
          ponha em seguida um bloco <b>Condição</b> na variável
          <code>bot_transferido</code>.
        </p>
      </template>

      <!-- ============ Mostrar ofertas ============ -->
      <template v-if="selected.type==='ofertas'">
        <div class="fhelp">
          Mostra os <b>cards das ofertas</b> que a consulta anterior encontrou e
          <b>espera o cliente escolher</b> uma. Depois que ele escolhe, o roteiro
          segue pela única saída deste bloco. Use o campo <b>Mensagem</b> lá em
          cima para o texto que aparece junto dos cards.
        </div>
        <p class="text-xs text-slate-500 mb-2">
          Ponha este bloco na saída <b>“achou oferta”</b> do bloco
          <b>Consultar oferta</b> — sem consulta antes, não há o que mostrar.
        </p>
      </template>
    </div>
    <p v-else class="text-xs text-slate-500 mt-3">Clique num bloco para editar o conteúdo dele.</p>

    <!-- problemas -->
    <div v-if="problems.length" class="mt-4 p-3 rounded-lg" style="background:rgba(241,92,109,.10)">
      <p class="text-xs font-semibold mb-1" style="color:#f15c6d">Revise antes de ativar:</p>
      <ul class="text-xs" style="list-style:disc;padding-left:18px">
        <li v-for="(p,i) in problems" :key="i">{{ p }}</li>
      </ul>
    </div>

    <!-- Simulador em moldura de celular: testar o roteiro vendo exatamente o que
         o cliente vê. Fica por cima de tudo, inclusive da tela cheia. -->
    <div v-if="sim" class="fsim-backdrop" @click.self="sim = null">
      <div class="fphone">
        <div class="fphone-notch" />
        <div class="fphone-screen">
          <div class="fphone-top">
            <div class="fphone-avatar">{{ (inbox.name || 'M').charAt(0).toUpperCase() }}</div>
            <div>
              <div class="fphone-name">{{ inbox.name || 'Atendimento' }}</div>
              <div class="fphone-status">online</div>
            </div>
          </div>

          <div ref="simScroll" class="fphone-body">
            <div v-for="(l,i) in sim.log" :key="i" class="fmsg-row" :class="'is-'+l.who">
              <div v-if="l.who==='sys'" class="fmsg-sys">{{ l.text }}</div>
              <div v-else class="fmsg" :class="l.who==='cli' ? 'is-out' : 'is-in'">{{ l.text }}</div>
            </div>

            <div v-if="sim.node && ['buttons','list','carousel'].includes(sim.node.type)" class="fsim-btns">
              <button v-for="(o,i) in simChoices(sim.node)" :key="i" type="button" @click="simPick(o)">
                {{ o.echo || o.label }}
              </button>
            </div>
          </div>

          <div class="fphone-composer">
            <template v-if="sim.node && sim.node.type==='input'">
              <input
                ref="simInput" type="text"
                :placeholder="sim.node.validate==='cpf' ? '000.000.000-00' : ('digite o '+(sim.node.field||'dado'))"
                @keydown.enter="simSend($event.target.value); $event.target.value=''"
              />
              <button type="button" class="fsend" @click="simSend($refs.simInput.value); $refs.simInput.value=''">➤</button>
            </template>
            <template v-else>
              <input type="text" :placeholder="sim.done ? 'Roteiro encerrado' : 'Aguardando o roteiro…'" disabled />
              <button type="button" class="fsend is-off" disabled>➤</button>
            </template>
          </div>
        </div>
        <div class="fphone-bar" />
      </div>

      <div class="fsim-actions">
        <button type="button" class="fsim-restart" @click="startSim">↻ Recomeçar</button>
        <button type="button" class="fsim-close" title="Fechar (Esc)" @click="sim = null">✕</button>
      </div>
    </div>

    <div v-if="!embedded" class="mt-5">
      <button type="button" class="button" :disabled="saving || loading" @click="save">
        {{ saving ? 'Salvando…' : 'Salvar roteiro' }}
      </button>
    </div>
  </div>
</template>

<style>
/* O Chatwoot alterna tema pela classe `dark` no html (tailwind darkMode:'class').
   Os blocos precisam de par fundo/texto próprio nos DOIS temas — herdar a cor do
   texto do tema por cima de um fundo fixo branco deixava tudo ilegível. */
.fcanvas {
  position: relative;
  height: 460px;
  overflow: hidden;
  cursor: grab;
  touch-action: none;
  background-color: #f8fafc;
  background-image:
    repeating-linear-gradient(0deg, rgba(100, 116, 139, 0.13) 0 1px, transparent 1px 20px),
    repeating-linear-gradient(90deg, rgba(100, 116, 139, 0.13) 0 1px, transparent 1px 20px);
  border: 1px solid rgba(100, 116, 139, 0.28);
}
.fcanvas:active { cursor: grabbing; }
/* Tela cheia: cobre a janela toda. z-index alto para passar por cima da barra
   lateral do Chatwoot; o Esc e o X vermelho voltam ao normal. */
.fcanvas.is-full {
  position: fixed;
  inset: 0;
  height: 100vh;
  width: 100vw;
  border-radius: 0;
  border: none;
  z-index: 9990;
}

/* ---- barra flutuante do canvas ------------------------------------------ */
.ftoolbar {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 20;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 7px 9px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(100, 116, 139, 0.22);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(8px);
}
.dark .ftoolbar {
  background: rgba(32, 44, 52, 0.94);
  border-color: rgba(148, 163, 184, 0.22);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
}
/* A barra é uma COLUNA de duas fileiras: blocos em cima, controles embaixo.
   Antes era um flex-wrap único e os controles quebravam misturados. */
.ftoolbar { flex-direction: column; align-items: stretch; gap: 8px; }
.ftrow { display: flex; flex-wrap: wrap; align-items: center; gap: 5px; }
.ftrow.is-ctl {
  gap: 8px; padding-top: 8px;
  border-top: 1px solid rgba(100, 116, 139, 0.18);
}
.dark .ftrow.is-ctl { border-top-color: rgba(148, 163, 184, 0.16); }
/* Cada grupo é uma "ilha" com fundo próprio: separa por função sem precisar
   de barrinhas divisórias. */
.fgrp {
  display: flex; align-items: center; gap: 5px; flex-wrap: wrap;
  padding: 4px 6px; border-radius: 10px;
  background: rgba(100, 116, 139, 0.10);
}
.dark .fgrp { background: rgba(148, 163, 184, 0.10); }
.fgrp.is-tpl { margin-left: auto; }        /* modelos encostam à direita */
.fgrp-tag {
  font-size: 10px; font-weight: 800; letter-spacing: .04em; text-transform: uppercase;
  color: #64748b; padding: 0 2px;
}
.dark .fgrp-tag { color: #94a3b8; }
.ftools-group { display: flex; align-items: center; gap: 5px; flex-wrap: wrap; }
.ftools-sep {
  width: 1px; height: 20px; margin: 0 3px;
  background: rgba(100, 116, 139, 0.28);
}
.dark .ftools-sep { background: rgba(148, 163, 184, 0.26); }

.ftool {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 600;
  padding: 5px 9px;
  border-radius: 8px;
  border: 1px solid rgba(100, 116, 139, 0.28);
  /* fundo SÓLIDO: transparente sumia no escuro do canvas */
  background: #f1f5f9;
  color: #334155;
  white-space: nowrap;
  cursor: pointer;
  transition: background .13s, border-color .13s, color .13s, transform .1s;
}
.ftool:hover:not(:disabled) { background: #e2e8f0; transform: translateY(-1px); }
.ftool:disabled { opacity: .45; cursor: default; }
.dark .ftool {
  color: #e2e8f0; border-color: rgba(148, 163, 184, 0.26);
  background: rgba(148, 163, 184, 0.16);
}
.dark .ftool:hover:not(:disabled) { background: rgba(148, 163, 184, 0.28); }
/* Blocos da paleta: leve destaque na borda para lerem como "peças". */
.ftool.is-block { background: #fff; }
.dark .ftool.is-block { background: rgba(255, 255, 255, 0.07); }
.ftool.is-block:hover { border-color: #00a884; color: #00a884; }
.dark .ftool.is-block:hover { color: #4fd1b0; }
/* Cores por função — o olho acha o botão sem ler. */
.ftool.is-view { background: #e0ecff; color: #1d4ed8; border-color: #93b4fd; }
.dark .ftool.is-view { background: rgba(59,130,246,.22); color: #93b4fd; border-color: rgba(59,130,246,.4); }
.ftool.is-save { background: #6d28d9; color: #fff; border-color: #6d28d9; }
.ftool.is-save:hover:not(:disabled) { background: #5b21b6; }
.ftool.is-use { background: #0ea5e9; color: #fff; border-color: #0ea5e9; }
.ftool.is-use:hover:not(:disabled) { background: #0284c7; }
.ftool.is-del { background: #fee2e2; color: #dc2626; border-color: #fca5a5; }
.dark .ftool.is-del { background: rgba(220,38,38,.18); color: #fca5a5; border-color: rgba(220,38,38,.35); }
.ftool:hover { border-color: #00a884; color: #00a884; background: rgba(0, 168, 132, 0.08); }
.ftool-ico { font-size: 13px; }
.ftool.is-icon {
  width: 28px; height: 28px; padding: 0;
  justify-content: center; font-size: 16px; font-weight: 700;
}
.ftool.is-test {
  border-color: #00a884; color: #fff; background: #00a884;
}
.ftool.is-test:hover { background: #01916f; color: #fff; }
.fzoom-val {
  font-size: 11.5px; font-weight: 700; min-width: 40px; text-align: center;
  color: #64748b;
}
.dark .fzoom-val { color: #9fb0ba; }

/* ---- simulador em moldura de iPhone -------------------------------------- */
.fsim-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  background: rgba(8, 12, 16, 0.72);
  backdrop-filter: blur(3px);
}
.fphone {
  position: relative;
  width: 330px;
  height: 668px;
  border-radius: 46px;
  padding: 11px;
  background: linear-gradient(160deg, #3a4148, #16191c 40%, #23282d);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(255, 255, 255, 0.07) inset;
  flex: 0 0 auto;
}
.fphone-notch {
  position: absolute;
  top: 20px; left: 50%; transform: translateX(-50%);
  width: 108px; height: 26px; border-radius: 14px;
  background: #0b0e10; z-index: 3;
}
.fphone-bar {
  position: absolute;
  bottom: 8px; left: 50%; transform: translateX(-50%);
  width: 128px; height: 4px; border-radius: 3px;
  background: rgba(255, 255, 255, 0.55); z-index: 3;
}
.fphone-screen {
  position: relative;
  height: 100%;
  border-radius: 36px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #0b141a;
}
.fphone-top {
  display: flex; align-items: center; gap: 9px;
  padding: 42px 14px 10px;
  background: #1f2c34;
  color: #e9edef;
  flex: 0 0 auto;
}
.fphone-avatar {
  width: 32px; height: 32px; border-radius: 50%;
  background: #00a884; color: #fff;
  display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 14px;
}
.fphone-name { font-size: 13.5px; font-weight: 600; line-height: 1.2; }
.fphone-status { font-size: 11px; color: #8fa3ad; }

.fphone-body {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background-color: #0b141a;
  background-image: radial-gradient(rgba(255, 255, 255, 0.025) 1px, transparent 1px);
  background-size: 18px 18px;
}
.fmsg-row { display: flex; }
.fmsg-row.is-cli { justify-content: flex-end; }
.fmsg-row.is-sys { justify-content: center; }
.fmsg {
  max-width: 78%;
  padding: 6px 9px;
  border-radius: 9px;
  font-size: 12.8px;
  line-height: 1.34;
  color: #e9edef;
  word-break: break-word;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
}
.fmsg.is-in { background: #202c33; border-top-left-radius: 2px; }
.fmsg.is-out { background: #005c4b; border-top-right-radius: 2px; }
.fmsg-sys {
  font-size: 11px;
  color: #cfd8dc;
  background: rgba(255, 255, 255, 0.08);
  padding: 4px 10px;
  border-radius: 8px;
}
.fsim-btns { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 4px; }
.fsim-btns button {
  border: 1px solid #00a884;
  color: #00a884;
  background: transparent;
  border-radius: 16px;
  padding: 6px 13px;
  font-size: 12.5px;
  font-weight: 600;
}
.fsim-btns button:hover { background: #00a884; color: #fff; }

.fphone-composer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 10px 26px;
  background: #1f2c34;
}
.fphone-composer input {
  flex: 1; min-width: 0; height: 34px;
  border-radius: 18px; padding: 0 13px;
  font-size: 12.8px;
  background: #2a3942; color: #e9edef;
  border: none;
}
.fphone-composer input::placeholder { color: #8696a0; }
.fphone-composer input:disabled { opacity: .75; }
.fsend {
  width: 34px; height: 34px; border-radius: 50%; border: none;
  background: #00a884; color: #fff; font-size: 14px; cursor: pointer;
  flex: 0 0 auto;
}
.fsend.is-off { background: #3a4a52; cursor: default; }

.fsim-actions { display: flex; flex-direction: column; gap: 10px; }
.fsim-restart {
  font-size: 12px; font-weight: 600; color: #fff;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 8px; padding: 7px 12px; white-space: nowrap;
}
.fsim-restart:hover { background: rgba(255, 255, 255, 0.24); }
.fsim-close {
  width: 40px; height: 40px; border-radius: 50%; border: none;
  background: #e02c3d; color: #fff; font-size: 18px; font-weight: 700;
  cursor: pointer; box-shadow: 0 3px 12px rgba(0, 0, 0, 0.4);
  align-self: center;
}
.fsim-close:hover { background: #c31f2f; }

.fclose {
  /* canto DIREITO: no centro ele caía em cima da paleta de blocos */
  position: fixed;
  top: 14px;
  right: 16px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: #e02c3d;
  color: #fff;
  font-size: 19px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.35);
}
.fclose:hover { background: #c31f2f; }

/* Painel do bloco selecionado vira flutuante em tela cheia, senão ficaria
   escondido embaixo do canvas. */
.fpanel { background: rgba(148, 163, 184, 0.07); }
.fpanel.is-full {
  position: fixed;
  top: 70px;
  right: 18px;
  z-index: 9995;
  width: 330px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid rgba(100, 116, 139, 0.3);
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.22);
}
.dark .fpanel.is-full {
  background: #1f2c34;
  border-color: rgba(148, 163, 184, 0.3);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.55);
}
.dark .fcanvas {
  background-color: #111b21;
  background-image:
    repeating-linear-gradient(0deg, rgba(148, 163, 184, 0.14) 0 1px, transparent 1px 20px),
    repeating-linear-gradient(90deg, rgba(148, 163, 184, 0.14) 0 1px, transparent 1px 20px);
  border-color: rgba(148, 163, 184, 0.22);
}

.fedge { stroke: rgba(71, 85, 105, 0.55); pointer-events: none; transition: stroke .12s; }
.dark .fedge { stroke: rgba(148, 163, 184, 0.6); }
/* Trilho invisível só para capturar o mouse — a curva de 2px é fina demais. */
.fedge-hit { stroke: transparent; pointer-events: stroke; cursor: pointer; }
.fedge-g:hover .fedge { stroke: #e02c3d; stroke-width: 2.5; }
/* Lixeira no meio da curva: só aparece com o mouse em cima da ligação. */
.fedge-del { opacity: 0; pointer-events: none; cursor: pointer; transition: opacity .12s; }
.fedge-g:hover .fedge-del { opacity: 1; pointer-events: all; }
.fedge-del circle { fill: #e02c3d; }
.fedge-del path { stroke: #fff; stroke-width: 2; stroke-linecap: round; }
.fedge-del:hover circle { fill: #c31f2f; }

.fcard {
  border-radius: 10px;
  padding: 9px 10px;
  cursor: move;
  background: #ffffff;
  color: #0f172a;
  border: 2px solid rgba(100, 116, 139, 0.35);
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.10);
  transition: border-color .15s, box-shadow .15s;
}
.fcard.is-selected {
  border-color: #00a884;
  box-shadow: 0 0 0 3px rgba(0, 168, 132, 0.18), 0 2px 8px rgba(15, 23, 42, 0.14);
}
.dark .fcard {
  background: #1f2c34;
  color: #e9edef;
  border-color: rgba(148, 163, 184, 0.30);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
}

.fcard-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .01em;
}
.fcard-start { color: #00a884; font-size: 11px; font-weight: 700; }

.fcard-text {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.3;
  word-break: break-word;
  color: #475569;
}
.dark .fcard-text { color: #aebac1; }

.fcard-meta { margin-top: 5px; font-size: 11.5px; font-weight: 600; color: #0f7c63; }
.dark .fcard-meta { color: #4fd1b0; }

.fcard-chips { margin-top: 6px; display: flex; flex-wrap: wrap; gap: 4px; }
.fchip {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 9px;
  background: rgba(0, 168, 132, 0.14);
  color: #0f7c63;
  border: 1px solid rgba(0, 168, 132, 0.30);
}
.dark .fchip {
  background: rgba(0, 168, 132, 0.20);
  color: #6ee7c4;
  border-color: rgba(0, 168, 132, 0.42);
}

/* Bolinha de saída: cheia = ligada, vazada = solta (é o aviso visual de que
   falta ligar aquele caminho). */
.fport {
  position: absolute;
  top: 86px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  cursor: crosshair;
  background: #ffffff;
  border: 2px solid #94a3b8;
  transition: transform .12s;
}
.fport:hover { transform: scale(1.25); }
.fport.is-linked { background: #00a884; border-color: #00a884; }
.dark .fport { background: #1f2c34; border-color: #94a3b8; }
.dark .fport.is-linked { background: #00a884; border-color: #4fd1b0; }

/* seletor de modelos na barra */
.ftool-sel {
  height: 28px; max-width: 150px; font-size: 12px; padding: 0 6px;
  border-radius: 7px; border: 1px solid rgba(148,163,184,.35);
  background: #fff; color: inherit;
}
.dark .ftool-sel { background: #1f2c34; border-color: rgba(148,163,184,.25); }
.ftool:disabled { opacity: .45; cursor: default; }

.fsplash-prev img{max-width:100%;max-height:120px;border-radius:8px;display:block}
/* nós de ação (HTTP / Supabase / Script) */
.fhelp { font-size: 11px; color: #64748b; margin-bottom: 8px; line-height: 1.4; }
.fhelp code { background: rgba(148,163,184,.18); padding: 0 4px; border-radius: 4px; }
.fx {
  width: 26px; flex: 0 0 26px; border-radius: 6px; border: 1px solid #e2426022;
  background: rgba(241,92,109,.12); color: #f15c6d; font-size: 12px;
}
.fadd {
  font-size: 12px; color: #00a884; background: rgba(0,168,132,.10);
  border: 1px dashed #00a88455; border-radius: 6px; padding: 4px 10px; display: inline-block;
}
.ftest {
  width: 100%; padding: 8px; border-radius: 8px; font-weight: 600; color: #fff;
  background: #0ea5e9; margin-top: 4px;
}
.ftest:disabled { opacity: .6; }
.fresult {
  margin-top: 8px; padding: 8px; border-radius: 8px; font-size: 11px;
  background: #0b141a; color: #93e6c8; max-height: 200px; overflow: auto;
  white-space: pre-wrap; word-break: break-word;
}
/* bancos do nó "Consultar oferta" */
.fbancos { display: flex; flex-wrap: wrap; gap: 6px; }
.fbanco {
  display: flex; align-items: center; gap: 6px; cursor: pointer; font-size: 12px;
  padding: 4px 10px; border-radius: 999px; background: rgba(148,163,184,.10);
  border: 1px solid rgba(148,163,184,.28);
}
.fbanco input { margin: 0; width: auto; }
</style>
